export class UserStatusModel {
  id: number;
  userStatus: string;
}
